import { AbilityBuilder, Ability } from '@casl/ability';
import {store} from '../redux/store';
function subjectName(item) {
  if (!item || typeof item === 'string') {
    return item
  }
  return item.__type
}
const ability = new Ability([], { subjectName });
let currentAuth;
store.subscribe(() => {
  const prevAuth = currentAuth;
  currentAuth = store.getState().Telepase.user;

  if (prevAuth !== currentAuth) {
    ability.update(defineRulesFor(currentAuth));
  }
});
function permissionToObject(string){
  var aux = string.split('.');
  var peraux = aux.slice((aux.length-1)*-1);
  return {codigo:aux[0], permissions:peraux}
}

function defineRulesFor(auth) {
  const { can, rules } = AbilityBuilder.extract();
  if (auth && auth.privilegios) {
    for (var i = 0; i < auth.privilegios.length; i++) {
      var object = permissionToObject(auth.privilegios[i].funcionSistemas);
      can(object.permissions, object.codigo)
    }
  }
  return rules;
}
export default ability;
